module.exports = __webpack_public_path__ + "static/media/Ebook.abc4de1f.png";